import React from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import { Button, Whisper, Popover } from 'rsuite';
import { Edit } from '@rsuite/icons';

const DeckHeader = ({
  collection,
  canEdit,
  tableData,
  validationLoading,
  onEditClick,
  onAddCardClick,
  onValidateClick,
  onImportClick,
  onMarkOwnedClick,
  onMarkUnownedClick,
  onConvertProxiesClick,
  onExportClick,
  onShareClick,
  onMoreMenuClick,
  onPlaytestClick,
  COLORS,
}) => {
  const hasProxies = tableData.some((e) => e.is_proxy);

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12, flexWrap: 'wrap' }}>
        <h3 style={{ margin: 0 }}>{collection.name}</h3>
        {canEdit && (
          <>
            {collection.type === 'DECK' && (
              <Button
                size="xs"
                appearance="primary"
                onClick={onEditClick}
                startIcon={<Edit />}
              >
                Edit
              </Button>
            )}
            <Button
              size="xs"
              appearance="primary"
              onClick={onAddCardClick}
            >
              Add Card
            </Button>
            {collection.type === 'DECK' && tableData.length > 0 && (
              <Button
                size="xs"
                appearance="primary"
                onClick={onValidateClick}
                loading={validationLoading}
              >
                Validate Deck
              </Button>
            )}
            {collection.type === 'DECK' && tableData.length > 0 && (
              <Button
                size="xs"
                appearance="ghost"
                data-testid="deck-playtest-action"
                onClick={onPlaytestClick}
              >
                Playtest
              </Button>
            )}
          </>
        )}
        {canEdit && (tableData.length > 0 || collection.type !== 'DECK') && (
          isMobile ? (
            <Button
              size="xs"
              appearance="ghost"
              onClick={onMoreMenuClick}
            >
              More
            </Button>
          ) : (
            <Whisper
              placement="bottomEnd"
              trigger="click"
              speaker={
                <Popover style={{ minWidth: 160 }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Button
                      block
                      size="sm"
                      appearance="ghost"
                      style={{ justifyContent: 'flex-start' }}
                      onClick={onImportClick}
                    >
                      Import Cards
                    </Button>
                    {collection.type === 'DECK' && tableData.length > 0 && (
                      <>
                        <div style={{ height: 1, backgroundColor: COLORS.border, margin: '4px 0' }} />
                        <Button
                          block
                          size="sm"
                          appearance="ghost"
                          style={{ justifyContent: 'flex-start' }}
                          onClick={onMarkOwnedClick}
                        >
                          Mark All Owned
                        </Button>
                        <Button
                          block
                          size="sm"
                          appearance="ghost"
                          style={{ justifyContent: 'flex-start' }}
                          onClick={onMarkUnownedClick}
                        >
                          Mark All Unowned
                        </Button>
                        {hasProxies && (
                          <Button
                            block
                            size="sm"
                            appearance="ghost"
                            style={{ justifyContent: 'flex-start' }}
                            onClick={onConvertProxiesClick}
                          >
                            Convert Proxies
                          </Button>
                        )}
                      </>
                    )}
                    <div style={{ height: 1, backgroundColor: COLORS.border, margin: '4px 0' }} />
                    {tableData.length > 0 && (
                      <Button
                        block
                        size="sm"
                        appearance="ghost"
                        style={{ justifyContent: 'flex-start' }}
                        onClick={onExportClick}
                      >
                        Export
                      </Button>
                    )}
                    <Button
                      block
                      size="sm"
                      appearance="ghost"
                      style={{ justifyContent: 'flex-start' }}
                      onClick={onShareClick}
                    >
                      Share
                    </Button>
                  </div>
                </Popover>
              }
            >
              <Button size="xs" appearance="ghost">
                More
              </Button>
            </Whisper>
          )
        )}
      </div>
      {!canEdit && collection.owner_username && (
        <p style={{ color: COLORS.muted, fontSize: 13, marginBottom: 8 }}>
          Shared by <strong>{collection.owner_username}</strong>
        </p>
      )}
      {collection.description && (
        <p style={{ color: COLORS.muted, fontSize: 13, marginBottom: 8 }}>
          {collection.description}
        </p>
      )}
    </>
  );
};

DeckHeader.propTypes = {
  collection: PropTypes.object.isRequired,
  canEdit: PropTypes.bool.isRequired,
  tableData: PropTypes.array.isRequired,
  validationLoading: PropTypes.bool,
  onEditClick: PropTypes.func.isRequired,
  onAddCardClick: PropTypes.func.isRequired,
  onValidateClick: PropTypes.func.isRequired,
  onImportClick: PropTypes.func.isRequired,
  onMarkOwnedClick: PropTypes.func.isRequired,
  onMarkUnownedClick: PropTypes.func.isRequired,
  onConvertProxiesClick: PropTypes.func.isRequired,
  onExportClick: PropTypes.func.isRequired,
  onShareClick: PropTypes.func.isRequired,
  onMoreMenuClick: PropTypes.func.isRequired,
  onPlaytestClick: PropTypes.func.isRequired,
  COLORS: PropTypes.object.isRequired,
};

DeckHeader.defaultProps = {
  validationLoading: false,
};

export default DeckHeader;
